var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelop = function SvgEnvelop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 88 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#D0D7DE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E7780",
    d: "M65 35.995V46.87l7-4.421v-.273zM54.158 24.019l-2.712.006-.009-.007L25.157 24l-.157.025V48.03l15.19 9.428 2.66-2.225a1 1 0 0 1 1.269-.011l3.362 2.712 15.52-9.802.049-24.107zM49.153 22l-5.662-5-5.365 4.914-.538.086zM23 35.322l-.094.53L16 42.175v.268l7 4.345zm0-2.268V23a1 1 0 0 1 1-1h10.36l.794-.077 6.986-6.398a2 2 0 0 1 2.675-.024l7.3 6.446.281.053H64a1 1 0 0 1 1 1v10.326l8.324 7.351a2 2 0 0 1 .676 1.5V78a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V42.176a2 2 0 0 1 .65-1.475zm49 11.76L49.126 59.261 72 77.715zM69.168 78 43.502 57.294 18.754 78zM16 77.696 38.575 58.81 16 44.798zM32 32h24a1 1 0 0 1 0 2H32a1 1 0 0 1 0-2m0 5h16a1 1 0 0 1 0 2H32a1 1 0 0 1 0-2"
  }))));
};
export default SvgEnvelop;